<template>
  <div>
    <div class="row">
      <div class="col-md-12 text-right mb-2">
        <button
          type="button"
          class="btn btn-primary"
          @click="save()"
          v-if="$store.getters.can('admin.rutas.editGeocercas')"
        >
          <i class="fas fa-save"></i> Guardar geocercas
        </button>
      </div>

      <div class="row w-100 mx-0">
        <div class="col-md-6">
          <div class="form-group">
            <label>Geocerca</label>
            <v-select
              v-model="geocerca"
              placeholder="Buscar geocerca..."
              label="nombre"
              class="form-control form-control-sm p-0"
              :class="[
                $v.form.sitio_id.$invalid ? 'is-invalid' : 'is-valid',
                $store.getters.getDarkMode ? 'dark-vselect' : '',
              ]"
              :options="listasForms.geocercas"
              :filterable="false"
              @search="buscarGeocercas"
              @input="selectGeocerca()"
            ></v-select>
          </div>
        </div>
        <!-- <div class="col-md-2">
          <div class="form-group">
            <label>Tiempo (min)</label>
            <input
              type="number"
              class="form-control form-control-sm"
              min="0"
              v-model="form.tiempo"
              :class="$v.form.tiempo.$invalid ? 'is-invalid' : 'is-valid'"
            />
          </div>
        </div> -->
        <div class="col-md-2">
          <div class="form-group">
            <label>Orden</label>
            <input
              type="text"
              class="form-control form-control-sm"
              disabled
              v-model="form.orden"
            />
          </div>
        </div>
        <div class="col-md-2 d-flex align-items-end">
          <div class="form-group w-100">
            <button
              v-show="!$v.form.$invalid"
              type="button"
              class="btn btn-success btn-block"
              @click="agregar()"
            >
              <i class="fa fa-plus"></i> Agregar
            </button>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="table-responsive">
          <table class="table table-bordered table-striped table-hover table-sm mb-0">
            <thead class="bg-dark text-white">
              <tr>
                <th style="width: 80px">Orden</th>
                <th>Nombre</th>
                <th>Tipo de Operación</th>
                <th>Dirección</th>
                <th style="width: 80px">Quitar</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="rutasGeocerca.length === 0">
                <td colspan="5" class="text-center text-muted py-4">
                  No hay geocercas asignadas a esta ruta.
                </td>
              </tr>
              <tr
                v-for="(item, index) in rutasGeocerca"
                :key="'geocerca-' + item.pivot.sitio_id + '-' + index"
              >
                <td class="text-center align-middle">
                  <span class="badge badge-primary">{{ item.pivot.orden }}</span>
                </td>
                <td class="align-middle">
                  <i class="fas fa-draw-polygon text-info mr-2"></i>
                  <strong>{{ item.nombre }}</strong>
                </td>
                <td class="align-middle">
                  {{ item.tipo_operacion_descripcion || item.tipoOperacion || "—" }}
                </td>
                <td class="align-middle">{{ item.direccion || "—" }}</td>
                <!-- <td class="text-center align-middle">{{ item.pivot.tiempo }}</td> -->
                <td class="text-center align-middle">
                  <button
                    type="button"
                    class="btn btn-danger btn-sm"
                    @click="quitar(index)"
                  >
                    <i class="fas fa-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import { required } from "vuelidate/lib/validators";

export default {
  name: "PlantRutaGeocerca",

  components: {
    vSelect,
  },

  data() {
    return {
      ruta_id: null,
      geocerca: null,
      nombre_geocerca: "",
      rutasGeocerca: [],
      geocercasAsignadas: [],
      form: {
        ruta_id: null,
        sitio_id: null,
        orden: 1,
      },
      listasForms: {
        geocercas: [],
      },
    };
  },

  validations: {
    form: {
      sitio_id: {
        required,
      },
      orden: {
        required,
      },
    },
  },

  methods: {
    getIndex() {
      this.form.ruta_id = this.$route.params.id;
      this.ruta_id = this.form.ruta_id;
      axios
        .get("/api/plant/rutas/geocercas/" + this.ruta_id)
        .then((response) => {
          this.rutasGeocerca = response.data;
          this.form.orden = this.rutasGeocerca.length + 1;
          this.getAsignadas();
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "No se pudieron cargar las geocercas: " + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    getAsignadas() {
      this.geocercasAsignadas = this.rutasGeocerca.map(
        (item) => item.pivot.geocerca_zona_id || item.pivot.sitio_id
      );
    },

    buscarGeocercas(search, loading) {
      if (search !== "") {
        const me = this;
        loading(true);
        axios
          .get("api/plant/basico/geocercaZona/lista", {
            params: {
              nombre: search,
              estado: 1,
              not_id: this.geocercasAsignadas,
            },
          })
          .then((response) => {
            me.listasForms.geocercas = response.data;
            loading(false);
          })
          .catch(() => {
            loading(false);
          });
      }
    },

    selectGeocerca() {
      this.form.sitio_id = null;
      if (this.geocerca) {
        this.form.sitio_id = this.geocerca.id;
        this.nombre_geocerca = this.geocerca.nombre;
      }
    },

    agregar() {
      if (this.$v.form.$invalid) {
        return;
      }

      const yaExiste = this.rutasGeocerca.some((item) => {
        const id = item.pivot.geocerca_zona_id || item.pivot.sitio_id;
        return id === this.form.sitio_id;
      });
      if (yaExiste) {
        this.$swal({
          icon: "warning",
          title: "Esta geocerca ya está asignada a la ruta",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }

      this.rutasGeocerca.push({
        pivot: {
          sitio_id: this.form.sitio_id,
          geocerca_zona_id: this.form.sitio_id,
          orden: this.form.orden,
          tiempo: this.form.tiempo,
        },
        nombre: this.nombre_geocerca,
        tipo_operacion: this.geocerca ? this.geocerca.tipo_operacion : null,
        tipo_operacion_descripcion: this.geocerca
          ? this.geocerca.tipoOperacion
          : null,
        direccion: this.geocerca ? this.geocerca.direccion : "",
        posicion: this.form.orden,
      });

      this.form = {
        ruta_id: this.ruta_id,
        sitio_id: null,
        orden: this.rutasGeocerca.length + 1,
        tiempo: 0,
      };
      this.geocerca = null;
      this.listasForms.geocercas = [];
      this.getAsignadas();
    },

    quitar(index) {
      this.$swal({
        title: "¿Quitar esta geocerca de la ruta?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, quitar",
      }).then((result) => {
        if (result.value) {
          for (let i = index + 1; i < this.rutasGeocerca.length; i++) {
            this.rutasGeocerca[i].pivot.orden =
              this.rutasGeocerca[i].pivot.orden - 1;
          }
          this.rutasGeocerca.splice(index, 1);
          this.form.orden = this.rutasGeocerca.length + 1;
          this.getAsignadas();
        }
      });
    },

    save() {
      axios
        .put("/api/plant/rutas/assingOrRevokeGeocerca", {
          ruta_id: this.ruta_id,
          arreglo: this.rutasGeocerca,
        })
        .then(() => {
          const sinGeocercas = this.rutasGeocerca.length === 0;
          this.getIndex();
          if (this.$parent.$refs.RutaDetalle) {
            this.$parent.$refs.RutaDetalle
              .cargarGeocercasMapa()
              .then(() => this.$parent.$refs.RutaDetalle.refrescarMapa());
          }
          this.$swal({
            icon: "success",
            title: sinGeocercas
              ? "Se guardó la ruta sin geocercas asignadas"
              : "Geocercas de la ruta actualizadas correctamente",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrió un error al guardar: " + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },
  },

  mounted() {
    this.getIndex();
  },
};
</script>
